import Vue from "vue";
import {api} from "@/store/api"
import axios from "axios"

export const state = {
  data: [],
  fetchErr: undefined
}

export const actions = {
  async get_reviews ({ commit }) {
    try {
      const { data } = await axios(api.reviews);
      commit('SET_REVIEWS_STATE', { key: 'data', value: data })
    } catch (err) {
      commit('SET_REVIEWS_STATE', { key: 'fetchErr', value: err.response?.data })
    }
  }
}

export const mutations = {
  SET_REVIEWS_STATE (state, { key, value }) {
    Vue.set(state, key, value);
  },
}
